import { Modal } from '@mui/material';
import { Spin } from 'antd';
import React from 'react'
import styled from 'styled-components';

const ContentLoading = ({ isLoading, isClose }) => {
    return (
      <Modal
        // className={classes.modal}
        open={isLoading}
      >
        <VideoContainer>
          <Spin size="large" style={{ position: 'absolute', top: '50%', left: '50%' }} />
        </VideoContainer>
      </Modal>
    );
  };

  export default ContentLoading;

  const VideoContainer = styled.div`
  height: auto;
  flex: 1;
  justify-content: center;
`;